window.$window = $(window);
window.$body = $('body');
window.page = $body.data('page');
window.$header = $('#header');
window.$wrapper = $('#wrapper');
window.spaceToHeaderFixed;
window.language = $('html').attr('lang');
window.timeTransitionDefault = 350;
window.texts = [];

window.texts['pt-BR'] = {
  quantity: 'quantidade',
  price: 'preço',
  cart_empty: 'O seu carrinho está vazio',
  go_product: 'Ir para a página do produto',
  btn_edit_cart: 'Editar pedido',
  btn_checkout: 'Finalizar pedido',
  btn_success: 'Adicionado!',
  errorsTxt: {
    withoutSku: 'Por favor, selecione o tamanho desejado',
  },
};

window.texts['en'] = {
  quantity: 'quantity',
  price: 'price',
  cart_empty: 'Empty cart',
  go_product: 'Go to product page',
  btn_edit_cart: 'Edit order',
  btn_checkout: 'Finish order',
  btn_success: 'Added!',
  errorsTxt: {
    withoutSku: 'Select a size to the product',
  },
};

function getText(key, subKey) {
  if (typeof subKey == 'undefined') {
    return texts[language][key];
  } else {
    return texts[language][key][subKey];
  }
}

window.store = {
  config: {
    // Seletor do botão de comprar
    selectorBtnBuy: '[data-action="add-cart"]',
    selectorBtnBuyAssinatura: '[data-action="add-cart-assinatura"]',
    // Seletor do elemento que engloba um produto
    selectorWrapperProduct: '[data-box-produto]',
    selectorWrapperProductAssinatura: '[data-box-produto-assinatura]',
    selectorFormProduct: '[data-form-product]',
    selectorFormProductAssinatura: '[data-form-product-assinatura]',
    // Se a store tem versão internacional ou não
    hasInternacionalVersion: true,
    errorsTxt: {
      withoutSku: getText('errorsTxt', 'withoutSku'),
    },
    // configuração de comportamento ao add um produto
    addToCartOpenCartpopup: true,
    addToCartOpenCartpopupMobile: true,
    cartCount: {
      selector: '[data-cart-count]',
      attr: '[data-cart-count-attr]',
      text: '[data-cart-item-text]',
    },
    priceProds: {
      selector: '[data-update-price]',
      attr: 'data-update-price',
      processedAttr: 'data-price-processed'
    },
  },
  formatMoney: function (value) {
    // FORMATA UM VALOR
    return (
      (language == 'pt-BR' ? 'R$ ' : '$') +
      value
      .toFixed(2)
      .replace('.', ',')
      .replace(/(\d)(?=(\d{3})+\,)/g, '$1.')
    );
  },
  validateQuantity: function (_val) {
    // VALIDA SE A QUANTIDADE INFORMADA É UM NÚMERO
    if (!isNaN(_val)) {
      if (parseInt(_val) > 0) {
        return true;
      }
    }

    return false;
  },
  getClearNumber: function (_val) {
    // RETORNA UM NÚMERO LIMPO COMO INT
    if (!isNaN(_val)) {
      clearNumber = parseInt(_val);

      return clearNumber;
    }

    return false;
  },

  findVariant: function (properties, variant_list) {
    return variant_list.filter(function (variant) {
      var match = true
      for (var property_key in properties) {
        var property1 = variant.properties['property1']
        var property2 = variant.properties['property2']
        var property3 = variant.properties['property3']

        if (property1 && property_key.includes(property1.name)) {
          var desired_property = property1.value
        } else if (property2 && property_key.includes(property2.name)) {
          var desired_property = property2.value
        } else if (property3 && property_key.includes(property3.name)) {
          var desired_property = property3.value
        }

        if (desired_property !== properties[property_key]) {
          match = false
        }
      }
      return match
    })
  },

  validateFormProduct: function (_$form) {
    // VALIDA O FORM DE PRODUTO PARA VER SE O PRODUTO PODE SER ADICIONADO
    var $parent = _$form.closest('[data-box-produto]');
    var $btnComprar = _$form.find('[data-action="add-cart"]');
    var validated = true;
    var errorsTxt = [];

    if ($btnComprar.data('available') == 'false') {
      validated = false;
      errorsTxt.push('');
    } else {
      //  verifica se o sku foi selecionado
      if (_$form.find('[name="sku"]').val() == '') {
        validated = false;
        errorsTxt.push(store.config.errorsTxt.withoutSku);
      }

      //  verifica se a quantidade é válida
      // console.log(_$form.find('input[name="quantity"]').val());
      if (_$form.find('input[name="quantity"]').val() <= 0) {
        // console.log('qtd invalida');
        validated = false;
        errorsTxt.push('Quantidade indisponível');
      }
    }

    return {
      validated: validated,
      errors: errorsTxt
    };
  },
  setRespValidateProduct: function (_resp, _$form, _$boxResponse) {
    // var $boxResult = _$form.find('.resp-validate');
    var $boxResult = _$boxResponse;
    var htmlErrors = '';

    if (_resp.validated) {
      $boxResult.empty();
    } else {
      for (var i = _resp.errors.length - 1; i >= 0; i--) {
        htmlErrors += '<span class="msg error">' + _resp.errors[i] + '</span>';
      }

      $boxResult.html(htmlErrors);
    }
  },
  addItemResultDefault: function (_$form, _typeResult, _result, _$boxResponse) {
    var _this = this;
    if (_typeResult == 'produto-adicionado') {
      var $btnComprar = _$form.find(_this.config.selectorBtnBuy);

      $btnComprar.addClass('success').html('Produto adicionado!');

      setTimeout(function () {
        // _$form.find('.msg-response').slideUp(350);
        $btnComprar.removeClass('success').html($btnComprar.data('text-available'));
      }, 3500);

      setTimeout(function () {
        window.location.href = urlCart;
      }, 150);
    } else if (_typeResult == 'erro-adicionar') {
      var errorText = JSON.parse(_result.responseText);

      if (typeof _$boxResponse != 'undefined' && _$boxResponse.length > 0) {
        console.info(errorText);

        _$boxResponse.addClass('error');
        _$boxResponse.removeClass('success');

        _$boxResponse.find('span').html(errorText.error);
        _$boxResponse.slideDown(350);

        setTimeout(function () {
          _$boxResponse.slideUp(350);
        }, 3500);
      }
    }
  },
  addItemResultDefaultAssinatura: function (_$form, _typeResult, _result, _$boxResponse) {
    var _this = this;
    if (_typeResult == 'produto-adicionado') {
      var $btnComprar = _$form.find(_this.config.selectorBtnBuyAssinatura);

      $btnComprar.addClass('success').html('Adicionado!');

      setTimeout(function () {
        // _$form.find('.msg-response').slideUp(350);
        $btnComprar.removeClass('success').html($btnComprar.data('text-available'));
      }, 3500);

      setTimeout(function () {
        window.location.href = urlAssinaturaCart;
      }, 150);
    } else if (_typeResult == 'erro-adicionar') {
      if (typeof _result == 'object') {
        var errorText = _result;
      } else {
        var errorText = JSON.parse(_result);
      }

      if (typeof _$boxResponse != 'undefined' && _$boxResponse.length > 0) {
        console.info(errorText);

        _$boxResponse.addClass('error');
        _$boxResponse.removeClass('success');

        _$boxResponse.find('span').html(errorText.error);
        _$boxResponse.slideDown(350);
      }
    }
  },
  addItem: function (_$form, _$parent, addItemResult) {
    var _this = this;
    var $btnComprar = _$parent.find('[data-action="add-cart"]');
    var urlAdd = '/carrinho/adicionar';
    var urlUpdate = '/carrinho';
    var url = urlAdd;
    var form = _$form.serialize();
    var $boxResponse = _$parent.find('[data-form-product] .msg-response');

    console.info('addItem');
    console.info('addItem', _$form.serializeArray());

    if (!$btnComprar.hasClass('adding')) {
      $.ajax({
          url: url,
          type: 'POST',
          dataType: 'json',
          data: form,
          beforeSend: function () {
            $btnComprar.addClass('adding');
          },
        })
        .done(function (resp) {
          // console.log('success');
          // console.info(resp);
          if (typeof template_store.addItemResult == 'function') {
            template_store.addItemResult(_$form, 'produto-adicionado', resp, $boxResponse);
          } else {
            template_store.addItemResultDefault(_$form, 'produto-adicionado', resp, $boxResponse);
          }
        })
        .fail(function (resp) {
          // console.log('error');
          // console.error(resp);
          // console.error(resp.responseText);
          // console.error(resp.responseText.error);

          if (typeof template_store.addItemResult == 'function') {
            template_store.addItemResult(_$form, 'erro-adicionar', resp, $boxResponse);
          } else {
            template_store.addItemResultDefault(_$form, 'erro-adicionar', resp, $boxResponse);
          }
        })
        .always(function () {
          // console.log('complete');
          $btnComprar.removeClass('adding');
        });
    }
  },
  addItemArray: function (skusToAddSet) {
    items = skusToAddSet.map(sku => ({
      sku,
      quantity: 1
    }));

    var data = JSON.stringify({
      items: items
    });

    return $.ajax({
      url: '/carrinho/adicionar/kit',
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      xhrFields: {
        withCredentials: true
      },
      cache: false,
      data: data
    })
  },
  addItemAssinatura: function (_$form, _$parent, addItemResult) {
    var _this = this;
    var $btnComprar = _$parent.find(store.config.selectorBtnBuyAssinatura);
    var url = urlAssinaturaCartAdd;
    var form = _$form.serialize();
    var $boxResponse = _$parent.find(
      store.config.selectorFormProductAssinatura + ' .msg-response'
    );
    var data = {};

    data.subscription_item = {
      quantity: _$form.find('[name="quantity"]').val(),
      sku: _$form.find('[name="sku"]').val(),
      extra: {
        vindi_plan_id: _$form.find('[name="extra[vindi_plan_id]"]').val(),
      },
    };

    console.info('addItemAssinatura');
    console.info('addItemAssinatura', data);
    console.info('addItemAssinatura', JSON.stringify(data));

    if (!$btnComprar.hasClass('adding')) {
      $.ajax({
          url: url,
          type: 'POST',
          // dataType: 'json',
          contentType: 'application/json',
          data: JSON.stringify(data),
          xhrFields: {
            withCredentials: true
          },
          beforeSend: function () {
            $btnComprar.addClass('adding');
          },
        })
        .done(function (resp) {
          // console.log('success');
          // console.info(resp);

          if (typeof template_store.addItemResult == 'function') {
            template_store.addItemResult(_$form, 'produto-adicionado', resp, $boxResponse);
          } else {
            template_store.addItemResultDefaultAssinatura(
              _$form,
              'produto-adicionado',
              resp,
              $boxResponse
            );
          }
        })
        .fail(function (xhr, status, error) {
          console.log('error');
          console.error(xhr);
          console.error(status);
          console.error(error);

          var resp = {
            error: 'Houve um problema ao adicionar. Tente mais tarde ou entre em contato.',
          };

          if (typeof template_store.addItemResult == 'function') {
            template_store.addItemResult(_$form, 'erro-adicionar', resp, $boxResponse);
          } else {
            template_store.addItemResultDefaultAssinatura(
              _$form,
              'erro-adicionar',
              resp,
              $boxResponse
            );
          }
        })
        .always(function () {
          // console.log('complete');
          $btnComprar.removeClass('adding');
        });
    }
  },
  addItemKit: function (forms, parent, cart) {
    const _this = this;

    let data = { items: [] }
    let quantity = Number(document.querySelector(`[name="quantity"]`).value);
    for (let index = 0; index < forms.length; index++) {
      const form = forms[index];
      if (form) {
        let input = form.querySelector('input[name="sku"]');
        if (input.value != '') {
          quantity = Number(document.querySelector(`[name="quantity"]`).value);
          console.log('selector quantity', quantity);
          if (cart != null) {
            if (cart.items.length > 0) cart.items.forEach(cartItem => {
              if (cartItem.variant_sku == input.value) {
                quantity += cartItem.quantity;
                console.log('new quantity', quantity);
              } 
            });
          }

          let hasItem = false;
          data.items.forEach(item => {
            if (item.sku == input.value) {
              item.quantity += quantity;
              hasItem = true;
            }
          });

          if (!hasItem) {
            data.items.push({
              sku: input.value,
              quantity: quantity
            })
          }
        }
      }
    }
    console.log('data', data);
    const json_data = JSON.stringify(data);

    // console.info('addItemKit', data);
    // console.info('addItemKit', json_data);

    const button = document.querySelector('.add-to-cart-button');
    if (!button.classList.contains('-sending')) {
      $.ajax({
        url: '/carrinho/adicionar/kit',
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        xhrFields: {
          withCredentials: true
        },
        cache: false,
        data: json_data,
        beforeSend: function () {
          button.classList.add('-sending');
        },
      })
        .done(function (resp) {
          // console.log('success');
          // console.info(resp);

          template_store.addItemResult($(forms), 'produto-adicionado', resp);

          _this.addKitLocalStorage(data.items);
        })
        .fail(function (resp) {
          console.log('error');
          console.error(resp);
          console.error(resp.responseText);
          console.error(resp.responseText.error);
        })
        .always(function () {
          // console.log('complete');
          button.classList.remove('-sending');
        });
    }
  },
  deleteItem: async function (_itemId, _$item, removeItemResult, update, key) {
    var _this = this;

    await $.ajax({
      url: '/carrinho',
      type: 'POST',
      dataType: 'json',
      data: {
        _method: 'delete',
        item_id: _itemId,
      },
      beforeSend: function () {
        _$item.addClass('removing');
      },
    })
    .done(function (_cart) {
      console.log('delete success');

      if (update) {
        window.componentCartDrawer.close();
        window.componentCartDrawer.open();
        localStorage.removeItem(key);
      }

      if (typeof removeItemResult == 'function') {
        removeItemResult(_$item, _cart);
      }
    })
    .fail(function (error) {
      console.log('erro ao remover', error.responseText);
    })
    .always(function () {
      _$item.removeClass('removing');
    });
    
  },
  addKitLocalStorage: function (items) {
    let names = '';
    let skus = '';

    items.forEach(item => {
      let input = document.querySelector(`[data-section-product] .attributes input[name="sku"][value="${item.sku}"]`);

      names += `${input.getAttribute('data-name')}//`;
      skus += `${item.sku}//`;
    })

    let itemName = 'combos-' + names;
    if (localStorage.getItem(itemName)) {
      itemName = `${Math.floor(Math.random() * 100)}${itemName}`;
      localStorage.setItem(itemName, skus);
    } else {
      localStorage.setItem(itemName, skus);
    }
  },
  setMsgResponse: function (_msg, _type, _$parent) {
    /*
      O tipo pode conter um dos 3 valores: success, warning, error ou CLEAR.
      O type CLEAR limpa as mensagens e faz sumir a mensagem
    */

    // Verifica se não há mais de uma mensagem
    // caso tenha, gera um html para cada mensagem
    if (Array.isArray(_msg)) {
      var msgArr = _msg;
      _msg = '';
      for (var i = msgArr.length - 1; i >= 0; i--) {
        _msg += '<span class="msg error">' + msgArr[i] + '</span>';
      }
    }

    _$parent
      .find('[data-msg-retorno]')
      .removeClass('success')
      .removeClass('warning')
      .removeClass('error');

    _$parent.find('[data-msg-retorno] [data-msg]').empty();

    if (_type != 'clear') {
      _$parent.find('[data-msg-retorno]').addClass(_type);
      _$parent.find('[data-msg-retorno] [data-msg]').html(_msg);
    }
  },
  updateCartCount: function (_itemsCount) {
    var _this = this;

    // $(_this.cartCount.selector).empty().text(_itemsCount);

    $(_this.config.cartCount.attr).data('cart-count-attr', _itemsCount);
    $(_this.config.cartCount.attr).attr('data-cart-count-attr', _itemsCount);

    $(_this.config.cartCount.attr).html(_itemsCount);
    $(_this.config.cartCount.text).html(_itemsCount);
    $(_this.config.cartCount.textLabel).html(_itemsCount > 1 ? 'itens' : 'item');

    if (_itemsCount > 0) {
      $('[data-cart-body]').parent().addClass('active');
    } else {
      $('[data-cart-body]').parent().removeClass('active');
    }
  },
  getCartCount: function () {
    async function getCartItens() {
      let itens;

      try {
        itens = await $.ajax({
          url: '/carrinho/itens',
          type: 'GET',
          dataType: 'text',
        });

        return itens;
      } catch (error) {
        console.error(error);
      }
    }

    if ($(store.config.cartCount.selector).length > 0) {
      getCartItens().then((total) => {
        var itens = Number.isInteger(parseInt(total));
        if (itens) {
          $(store.config.cartCount.attr).attr('data-cart-count-attr', total);
          $(store.config.cartCount.selector).html(total);

          var $boxCart = $('[data-cart-body]');

          if ($boxCart.length > 0) {
            if (total > 0) {
              template_store.headerCart.loadCart(total);
            } else {
              $boxCart.html('<div class="empty"><p>Seu carrinho está vazio...</p></div>');
            }
          }
        }
      });
    }
  },

  getCartItens: async function () {
    try {
      const cart = await $.ajax({
        url: '/carrinho',
        type: 'GET',
        dataType: 'json',
      })

      console.log(cart);

      return cart.items;

    } catch (error) {
      console.error('Erro ao buscar a quantidade de produtos do carrinho');
      console.error(error);
    }
  },

  setFilterSelected: function () {
    var sPageURL = decodeURI(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      // console.log('nome do parametro', sParameterName[0])
      // console.log('valor do parametro', sParameterName[1])

      if ($('.filters-form [name="' + sParameterName[0] + '"][value="' + sParameterName[1] + '"]').length > 0) {
        $('.filters-form [name="' + sParameterName[0] + '"][value="' + sParameterName[1] + '"]').closest('li').addClass('selected')
        $('.filters-form [name="' + sParameterName[0] + '"][value="' + sParameterName[1] + '"]').attr('checked', true)
      }
    }
  },

  setFilters: function () {
    $('[data-action="toggle-filter"]').on('click', function () {
      $(this).toggleClass('active')

      if ($('#filters').innerHeight() > 0) {
        $('#filters').css('height', 0)
      } else {
        $('#filters').css('height', $('#filters').find('.form-filter').innerHeight() + 25)
      }
    });
  },

  setImagesBetweenProducts: function () {
    const $imagesBetweenProducts = $('.banner-image');
    let productsLength = $('.product-block').length;

    $imagesBetweenProducts.each(function (index, el) {
      const $el = $(el);

      $el.data('index') > 28 && $el.css('order', $el.data('index') + 1)

      productsLength < $el.data('index') ? $el.hide() : $el.show();
    })
  },

  setQuickView: function () {
    let quickViews = document.querySelectorAll('[data-action="quick-view"]');

    if (quickViews) {
      quickViews.forEach(quickView => {
        quickView.addEventListener('click', (event) => {
        
          let url = quickView.dataset.url;
          let popupDefault = document.querySelector('[data-component="popup"]');
          let iframe = `<iframe src="${url}?version=quickview" id="myFrame" data-iframe></iframe>`;
          
          if (event.target.tagName === 'IMG') {
            event.preventDefault();
            popupDefault.querySelector('.content').innerHTML = iframe;
            
            setTimeout(function () {
              popupDefault.classList.add('visible');
              window.parent.document.getElementsByTagName('html')[0].style.overflow = 'hidden';
            }, 400)

            // Dá um update na URL para fins de tracking (solicitado pelo cliente)
            history.pushState(url, 'Quick View URL', url); 
            
            // Pega o iframe do quick view
            var iframeQuickView = document.getElementById("myFrame");
            
            // Espera o carregamento do iframe 
            iframeQuickView.onload = () => {
              let DataProductDocument =  iframeQuickView.contentWindow.document.querySelectorAll('[data-product-block]');
              DataProductDocument.forEach((el)  =>  {
                el.addEventListener('click', ()=>{
                  url = el.querySelector('a').getAttribute("href");
                  url = url.replace('?version=quickview', '');
                  history.pushState(url, 'Quick View URL de dentro do QuickView', url);
                })
              })
              var whatsApp = iframeQuickView.contentWindow.document.querySelectorAll('.MuiScopedCssBaseline-root')
            }
          }
        })
      })
      
      window.addEventListener("message", function (e) {
        if (e.data[0] == 'produto-adicionado-quick-view') {
          //window.location.href = urlCart;

          var cartResult = e.data[1];

          popupDefault.classList.remove('visible');
          window.parent.document.getElementsByTagName('html')[0].style.overflow = '';

          if ($body.width() > 768) {
            if (store.config.addToCartOpenCartpopup) {
              template_store.headerCart.loadCart(cartResult);
              template_store.headerCart.show();
            }
          } else {
            if (store.config.addToCartOpenCartpopupMobile) {
              template_store.headerCart.loadCart(cartResult);
              template_store.headerCart.show();
            }
          }

        } else if (e.data[0] == 'interna-do-produto') {
          window.location.href = e.data[1];
        }
      }, false);

      var qvLink = document.querySelector('[data-qv-link]');
      if (qvLink) {
        qvLink.addEventListener('click', function (e) {
          e.preventDefault();

          window.parent.postMessage(['interna-do-produto', this.href], '*');
        })
      }

    }

  },

  setTopBar: function () {
    var topBar = new Swiper('[data-top-bar]', {
      spaceBetween: 0,
      autoplay: true,
      speed: 3000,
      slidesPerView: 1,
      autoplay: {
        delay: 4000,
      },
      loop: true,
    });
  },

  setSearchForm: function () {
    const $openForm = $('[data-action="toggle-search"]')
    const $searchForm = $('[data-form-search]')
    const $searchInput = $searchForm.find('input')

    $openForm.on('click', function () {
      $searchForm.toggleClass('open')
      $searchForm.hasClass('open') ? $searchInput.focus() : $searchInput.blur();
    })
  },

  setQuickBuy: function () {
    $(document).on('change', '[data-product-block] [data-product-attributes] .input', function (event) {
      let form = event.target.closest('form');
      let productWrapper = event.target.closest('[data-product-block]');
      let inputs = Array.from(form.querySelectorAll('input:checked'));
      let productId = form.dataset.productId;
      let attributes = inputs.reduce((map, input) => ({
        ...map,
        [input.name]: input.value
      }), {});

      let variant = store.findVariant(attributes, listVariantsProducts['productId' + productId]);
      let btnBuy = form.querySelector('[data-action="add-cart"]');
      let boxMessage = form.querySelector('.msg-response .msg');

      boxMessage.innerHTML = '';
      btnBuy.innerHTML = '';
      btnBuy.insertAdjacentHTML('beforeend', btnBuy.dataset.textAvailable);
      btnBuy.classList.remove('-unavailable');
      form.querySelector('[name=sku]').setAttribute('value', '');

      if (variant.length < 1) {
        btnBuy.innerHTML = '';
        btnBuy.insertAdjacentHTML('beforeend', btnBuy.dataset.textUnavailable);
        btnBuy.classList.add('-unavailable');
        productWrapper.querySelector('.price').innerHTML = 'ESGOTADO';
      } else if (variant.length == 1) {
        if (!variant[0].available) {
          btnBuy.innerHTML = '';
          btnBuy.insertAdjacentHTML('beforeend', btnBuy.dataset.textUnavailable);
          btnBuy.classList.add('-unavailable');
          productWrapper.querySelector('.price').innerHTML = 'ESGOTADO';

          if (language == 'pt-BR') {
            boxMessage.innerHTML = 'Tamanho indisponível';
          } else {
            boxMessage.innerHTML = 'Size unavailable';
          }
        } else {
          form.querySelector('[name=sku]').setAttribute('value', variant[0].sku);

          if (productWrapper.querySelector('.price')) {
            productWrapper.querySelector('.price').innerHTML = '';
  
            if (language == 'pt-BR') {
              productWrapper.querySelector('.price').insertAdjacentHTML('beforeend',
                variant[0].price !== variant[0].sale_price ?
                `<del>${store.formatMoney(variant[0].price)}</del><ins>${store.formatMoney(variant[0].sale_price)}</ins>` :
                store.formatMoney(variant[0].price)
              );
            } else {
              productWrapper.querySelector('.price').insertAdjacentHTML('beforeend', store.formatMoney(variant[0].intl_price).replace(',', '.'));
            }
          }

          $(btnBuy).trigger('click');
        }
      } else {
        if (language == 'pt-BR') {
          boxMessage.innerHTML = 'Selecione +1 atributo';
        } else {
          boxMessage.innerHTML = 'Select +1 attribute';
        }
      }
    })

    $(document).on('submit', '[data-product-block] [data-form-product]', function (event) {
      event.preventDefault();

      var $form = $(this);
      var $parent = $form.closest('[data-form-product]');

      var respValidated = store.validateFormProduct($form);
      var $boxResponse = $parent.find('.add-to-cart-button');

      if (respValidated.validated) {
        store.addItem($form, $parent, function (_$form, _typeResult, _result, _$boxResponse) {
          template_store.addItemResult(_$form, _typeResult, _result, _$boxResponse);
        });
      } else {
        //console.info('não foi');
        store.setRespValidateProduct(respValidated, $form, $boxResponse);
      }
    })
  },

  setMenuMobile: function () {
    const $btnToggleMenuMobile = $('[data-action="toggle-side-menu"]');
    const $btnOpenSubmenu = $('[data-action="open-submenu"]');
    const $btnCloseSubmenu = $('[data-action="close-submenu"]');
    const $overlay = $('[data-overlay-menu-mobile]');

    function closeSubmenu() {
      $('.submenu-list').removeClass('active');
      $btnToggleMenuMobile.find('svg').toggleClass('active');
      $('.side-nav').toggleClass('open');
      $overlay.toggleClass('active');
      $('[svg-submenu]').removeClass('active');
    }

    $btnToggleMenuMobile.on('click', () => {
      closeSubmenu();
    });

    $overlay.on('click', () => {
      closeSubmenu();
    })

    $btnOpenSubmenu.on('click', function () {
      if ($(this).siblings('.submenu-list').hasClass('active')) {
        $(this).find('[svg-submenu]').removeClass('active');
        $(this).siblings('.submenu-list').removeClass('active');
      } else {
        $('.submenu-list').removeClass('active');
        $('[svg-submenu]').removeClass('active');
        $(this).find('[svg-submenu]').addClass('active');
        $(this).siblings('.submenu-list').addClass('active');
      }
    })

    $btnCloseSubmenu.on('click', function () {
      $(this).closest('.submenu-list').removeClass('active');
    })
  },

  setToggleFooter: function () {
    const $toggleFooter = $('[data-toggle-footer]');
    const $toggleMenu = $('[data-toggle-menu]')

    if ($body.width() > 992) $('.column-menu ul').toggleClass('active');

    $toggleMenu.on('click', function () {
      if ($body.width() <= 992) {
        if ($(this).siblings('ul').hasClass('active')) {
          $(this).siblings('ul').removeClass('active');
          $(this).removeClass('active')

        } else {
          $('.column-menu ul').removeClass('active')
          $('[data-toggle-menu]').removeClass('active')
          $(this).addClass('active')
          $(this).siblings('ul').addClass('active')
        }
      }
    })
  },

  setProductsCarousel: function () {
    // Inicializa os carrosseis de produtos default
    $('[data-products-carousel]').each(function (index, el) {

      // Pega a quantidade de itens que o carrossel contém
      var qtdItems = $(el).find('[data-item]').length;

      var swiperProductsCarousel = new Swiper($(el), {
        lazy: {
          checkInView: true,
          loadOnTransitionStart: true,
          loadPrevNext: true,
          loadPrevNextAmount: 1
        },
        slidesPerView: 4,
        watchOverflow: true,
        breakpoints: {
          325: {
            slidesPerView: 2,
            spaceBetween: 15
          },
          640: {
            spaceBetween: 21,
            slidesPerView: 3,
          },
          1200: {
            spaceBetween: 21,
            slidesPerView: 4,
          },
        },
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: $(el).closest('.wrapper-products').find('.swiper-button-next'),
          prevEl: $(el).closest('.wrapper-products').find('.swiper-button-prev'),
        },
        pagination: {
          el: $(el).closest('.wrapper-products').find('.swiper-pagination'),
          type: 'progressbar',
          clickable: true
        }
      });
    });
  },

  submitForm: function (_$form) {
    _$form.find('[name="reply_to"]').val(_$form.find('[name="email"]').val());
    var dataForm = _$form.serialize();
    var contentTypeForm = 'application/x-www-form-urlencoded; charset=UTF-8';
    var processDataForm = true;

    if (_$form.find('input[type="file"]').val() != '') {
      inputFile = _$form.find('input[type="file"]')[0];
      dataForm = new FormData(_$form[0]);
      contentTypeForm = false;
      processDataForm = false;
    }

    if (!_$form.hasClass('sending')) {
      $.ajax({
          url: '/webform',
          type: 'POST',
          data: dataForm,
          contentType: contentTypeForm,
          processData: processDataForm,
          beforeSend: function () {
            _$form.addClass('sending');
          },
        })
        .done(function () {
          // console.info('foi');
          // store.setMsgResponse('Mensagem enviada com sucesso!', 'success', _$form);
          _$form.find('[data-msg-retorno] [data-msg-success]').addClass('visible');
          _$form.find('[data-msg-retorno] [data-msg-error]').removeClass('visible');

          if (_$form.data('webform') == 'newsletter') {
            store.setMsgResponse('Mensagem enviada com sucesso!', 'success', _$form);
          } else {
            _$form.find('button[type=submit]').text('Enviado');
          }

          setTimeout(function () {
            if (_$form.data('webform') != 'newsletter') {
              _$form.find('button[type=submit]').text('Enviar');
            }
          }, 3500);
          _$form[0].reset();
        })
        .fail(function () {
          // console.info('foi, mas deu ruim');
          _$form.find('[data-msg-retorno] [data-msg-success]').removeClass('visible');
          _$form.find('[data-msg-retorno] [data-msg-error]').addClass('visible');
          _$form.find('button[type=submit]').text('Falha ao enviar');
          setTimeout(function () {
            _$form.find('button[type=submit]').text('Enviar');
          }, 3500);
          // store.setMsgResponse('Houve um problema ao enviar sua mensagem, tente novamente! Ou entre em contato conosco pelo telefone (21) 99644-6925 ', 'error', $form);
        })
        .always(function () {
          // console.log('complete');
          _$form.removeClass('sending');
        });
    }
  },

  getPriceProd: function () {
    const {
      selector,
      attr,
      processedAttr
    } = store.config.priceProds;
    const products = document.querySelectorAll(selector);

    if (products.length > 0) products.forEach(product => {
      const processed = product.getAttribute(processedAttr);
      const page = product.getAttribute('data-page');

      if (processed != 'true') {
        const prodId = product.getAttribute(attr);
        const url = `/produto/preco/${prodId}${page ? `?page=${page}` : ''}`;

        if (prodId != null && prodId != '') {
          $.ajax({
              url: url,
              type: 'GET',
            })
            .done(function (resp) {
              // console.info(resp);
              product.innerHTML = resp;
              product.setAttribute(processedAttr, true);
            })
            .fail(function (resp) {
              // console.error(`Falha ao buscar o preço do produto ${prodId}`);
              // console.log(resp);
            });
        }
      }
    })
  },

  login: {
    validateLogin: function (_$form) {
      var validated = true;
      var errorsTxt = [];

      if (_$form.find('[name="email"]').val() == '') {
        validated = false;
        errorsTxt.push('Informe seu email!');
      }

      if (_$form.find('[name="password"]').val() == '') {
        validated = false;
        errorsTxt.push('Informe a senha!');
      }

      return {
        validated: validated,
        errors: errorsTxt
      };
    },
    validateRegister: function (_$form) {
      var validated = true;
      var errorsTxt = [];

      if (_$form.find('[name="email"]').val() == '') {
        validated = false;
        errorsTxt.push('Informe seu email!');
      }

      if (_$form.find('[name="password"]').val() == '') {
        validated = false;
        errorsTxt.push('Informe uma senha!');
      }

      if (_$form.find('[name="password"]').val() != '') {
        var pass = _$form.find('[name="password"]').val();
        var confirmationPass = _$form.find('[name="password_confirmation"]').val();

        if (pass != confirmationPass) {
          validated = false;
          errorsTxt.push('Senha e confirmação são diferentes!');
        }
      }

      return {
        validated: validated,
        errors: errorsTxt
      };
    },
    validateRecover: function (_$form) {
      var validated = true;
      var errorsTxt = [];

      if (_$form.find('[name="email"]').val() == '') {
        validated = false;
        errorsTxt.push('Informe seu email!');
      }

      return {
        validated: validated,
        errors: errorsTxt
      };
    },
    logar: function (_$form) {
      if (!_$form.hasClass('sending')) {
        $.ajax({
            url: '/entrar',
            type: 'POST',
            dataType: 'json',
            data: _$form.serialize(),
            beforeSend: function () {
              _$form.addClass('sending');
            },
          })
          .done(function (resp) {
            // console.log('success', resp);

            if (resp.error) {
              store.setMsgResponse(resp.error, 'error', _$form);
            }

            if (resp.client) {
              window.location.href = resp.redirect_to;
            }
          })
          .fail(function (resp) {
            console.error('error', error.responseText);
          })
          .always(function () {
            // console.log('complete');
            _$form.removeClass('sending');
          });
      }
    },
    recoverPassord: function (_$form) {
      if (!_$form.hasClass('sending')) {
        $.ajax({
            url: '/recuperar_senha',
            type: 'POST',
            dataType: 'json',
            data: _$form.serialize(),
            beforeSend: function () {
              _$form.addClass('sending');
            },
          })
          .done(function (resp) {
            // console.log('success', resp);

            if (resp.error) {
              store.setMsgResponse(resp.error, 'error', _$form);
            }

            if (resp.ok) {
              store.setMsgResponse(resp.ok, 'success', _$form);
            }

            /*if (resp.client) {
              window.location.href = resp.redirect_to;
            }*/
          })
          .fail(function (resp) {
            console.error('error', error.responseText);
          })
          .always(function () {
            // console.log('complete');
            _$form.removeClass('sending');
          });
      }
    },
  },

  throttle: function (fn, threshhold, scope) {
    threshhold || (threshhold = 250);
    var last, deferTimer;
    return function () {
      var context = scope || this;

      var now = +new Date(),
        args = arguments;
      if (last && now < last + threshhold) {
        // hold on to it
        clearTimeout(deferTimer);
        deferTimer = setTimeout(function () {
          last = now;
          fn.apply(context, args);
        }, threshhold);
      } else {
        last = now;
        fn.apply(context, args);
      }
    };
  },
};

window.template_store = {
  /* 
    Manda um ajax para o form de avise-me e também para um form da plataforma para o cliente receber um email
  */
  submitFormNotify: function (_$form) {
    var formData = _$form.serialize();

    if (!_$form.hasClass('sending') && _$form.find('[name="sku"]').val() != '') {
      $.ajax({
          url: _$form.attr('action'),
          type: 'post',
          dataType: 'json',
          data: formData,
          beforeSend: function () {
            _$form.addClass('sending');
          },
        })
        .done(function (resp) {
          // console.log('success');
          // console.info(resp);

          var msgSuccess = 'Você receberá um e-mail quando o produto estiver disponível';

          if (resp.error) {
            _$form.find('[data-msg-retorno] [data-msg-error]').html(resp.error);
            _$form.find('[data-msg-retorno] [data-msg-success]').removeClass('visible');
            _$form.find('[data-msg-retorno] [data-msg-error]').addClass('visible');
          } else {
            // Envia um email para o cliente saber que o usuário solicitou o avise-me
            $.ajax({
                url: '/webform',
                type: 'POST',
                data: {
                  key: _$form.find('[name="key"]').val(),
                  reply_to: _$form.find('[name="email"]').val(),
                  email: _$form.find('[name="email"]').val(),
                  product_name: _$form.find('[name="produto"]').val(),
                  referencia: _$form.find('[name="referencia"]').val(),
                  sku: _$form.find('[name="sku"]').val(),
                },
              })
              .done(function (resp) {
                _$form.find('[data-msg-retorno] [data-msg-success]').addClass('visible');
                _$form.find('[data-msg-retorno] [data-msg-attr]').removeClass('active');
                _$form.find('[data-msg-retorno] [data-msg-error]').removeClass('visible');

                _$form[0].reset();
              })
              .fail(function (error) {
                _$form.find('[data-msg-retorno] [data-msg-success]').removeClass('visible');
                _$form.find('[data-msg-retorno] [data-msg-error]').addClass('visible');
              });
          }
        })
        .fail(function (resp) {
          console.log('error');
          console.error(resp);
          console.error(resp.responseText);
          console.error(resp.responseText.error);

          var errorText = JSON.parse(resp.responseText);
          console.info(errorText);
          
          _$form.find('[data-msg-retorno] [data-msg-error]').html(errorText.error);
          _$form.find('[data-msg-retorno] [data-msg-success]').removeClass('visible');
          _$form.find('[data-msg-retorno] [data-msg-error]').addClass('visible');
        })
        .always(function () {
          _$form.removeClass('sending');
        });
    }
  },
  /* 
    Função que executa o comportamento de quando o produto é adicionado no carrinho
  */
  addItemResult: function (_$form, _typeResult, _result, _$boxResponse) {
    var _this;
    var $btnComprar = _$form.find(store.config.selectorBtnBuy);

    if (document.location.search.includes('quickview')) {
      var parentWindow = window.parent;
      parentWindow.postMessage(['produto-adicionado-quick-view', _result], '*');

    } else if (_typeResult == 'produto-adicionado') {
      

      $btnComprar.addClass('success').html(getText(language));

      setTimeout(function () {
        // _$form.find('.msg-response').slideUp(350);
        $btnComprar.removeClass('success').html($btnComprar.data('text-available'));
      }, 3500);

      if (language !== 'pt-BR') {
        window.location.href = urlCart;
      }

      if ($body.width() > 768) {
        if (store.config.addToCartOpenCartpopup) {
          template_store.headerCart.loadCart(_result);
          template_store.headerCart.show();
        } else {
          setTimeout(function () {
            window.location.href = urlCart;
          }, 150);
        }
      } else {
        if (store.config.addToCartOpenCartpopupMobile) {
          template_store.headerCart.loadCart(_result);
          template_store.headerCart.show();
        } else {
          setTimeout(function () {
            window.location.href = urlCart;
          }, 150);
        }
      }
    } else if (_typeResult == 'erro-adicionar') {
      var errorText = JSON.parse(_result.responseText);

      if (typeof _$boxResponse != 'undefined' && _$boxResponse.length > 0) {
        console.info(errorText);

        _$boxResponse.addClass('error');
        _$boxResponse.removeClass('success');

        if (_result.responseText.includes('sku')) 
          _$boxResponse.html(`<span>Por favor, selecione o tamanho desejado</span>`)
      }
    }
  },
  validateFormNewsletter: function (_$form) {
    var validated = true;
    var errorsTxt = [];

    if (_$form.find('[name="email"]').val() == '') {
      validated = false;
      errorsTxt.push('Informe seu email!');
      console.log('vazio email')
    }

    if (_$form.find('[name="nome"]').val() == '') {
      validated = false;
      console.log('vazio nome')
      errorsTxt.push('Informe seu nome!');
    }

    return {
      validated: validated,
      errors: errorsTxt
    };
  },
  headerCart: {

    loadCart: function (total) {
      store.updateCartCount(total.items_count);
      window.componentCartDrawer.open();
    },

    show: function () {
      window.componentCartDrawer.open();
    },

    toggleBtn: function () {
      function waitForElm(selector) {
        return new Promise(function (resolve) {
          if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
          }
          var observer = new MutationObserver(function(mutations) {
            if (document.querySelector(selector)) {
              resolve(document.querySelector(selector));
              observer.disconnect();
            }
          });
          observer.observe(document.body, {
            childList: true,
            subtree: true
          });
        });
      }
      waitForElm('#cart-drawer-el .cart-drawer-pt-2 .card-drawer-cta').then(function(btn) {
        if (!localStorage.getItem('logged-in')) {
          console.log('not logged in, button:', btn);

          let newBtn = btn.cloneNode(true);
          btn.parentNode.insertBefore(newBtn, btn);
          btn.remove();

          newBtn.addEventListener('click', () => {
            window.location.href = '/entrar';
          });
        }
      });
    },

    deleteKits: async function (name) {
      const items = { ...localStorage };

      const cartItems = await store.getCartItens(true);
      Object.entries(items).forEach(([key, value]) => {
        if (key.includes('combos-')) {
          const productNames = key.split('combos-')[1].split('//');
          const skus = value.split('//');

          console.log('Itens', skus);
  
          if (productNames.length > 0) productNames.forEach(pName => {
            if(pName.toLowerCase() == name.toLowerCase()) {
              skus.forEach((sku, i) => {
                if (sku && sku != null && sku != '') {
                  cartItems.forEach(async function (cartItem) {
                    console.log(i);
                    if (cartItem.variant_sku == sku) {
                      const id = cartItem.id;
                      await store.deleteItem(id, $(document.body), '', i == (skus.length - 2), key);
                    }
                  });
                }
              });
            }
          });
        }
      });
    },
  
    observeKits: function () {
      const { deleteKits } = this;
      let cartEl = document.querySelector('#component-cart-drawer-root');
      let observer = new MutationObserver(mutation => {
        let cartItems = cartEl.querySelectorAll('.cart-item:not(.-ready)');
        if (cartItems.length > 0) cartItems.forEach((item, index) => {

          let name = item.querySelector('.cart-list-item-name a');
          if (name.innerText.includes('[CONJUNTO]')) {
  
            let buttonTrash = item.querySelector('.cart-buttons-trash');
            let wrapperTrash = buttonTrash.parentElement;

            if (index == 1) {
              wrapperTrash.classList.add('-remove');
            }
            
            let newButton = buttonTrash.cloneNode(true);
            newButton.addEventListener('click', () => {
              deleteKits(name.innerText);
            });
  
            buttonTrash.remove();
            wrapperTrash.appendChild(newButton);
  
            if (item.querySelector('.cart-buttons-min')) item.querySelector('.cart-buttons-min').remove();
            if (item.querySelector('.cart-buttons-plus')) item.querySelector('.cart-buttons-plus').remove();
  
            item.classList.add('-ready');
          }
        });
      });
      observer.observe(cartEl, { attributes: true, childList: true, subtree: true });
    },

  },
  /*
    Debounce retorna uma função que enquanto continuar sendo chamada não é executada
    A função só será executada quando para de ser chamada por N milisegundos
    Útil para melhorar a performance de códigos que são executados muitas vezes por segundo, como o $(window).resize()

    Ex:
    
    $(window).resize(debounce(function() {
      // código a ser executado
    }, 500))
    
    No exemplo acima a função só será executada 500ms depois do último resize
    Abra o link abaixo e redimensione a janela branca e acompanhe o output do console
    Exemplo codepen: https://codepen.io/valkervieira/pen/oNgqyWY

    Um caso comum de uso é em lojas onde a seleção de um filtro na página de tag recarrega automáticamente a página
    Com o debounce o usuário pode escolher vários filtros rapidamente e a página só recarrega quando parar de escolher
  */
  debounce: function (func, wait, immediate = true) {
    var timeout;

    return function () {
      var context = this,
        args = arguments;

      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;

      clearTimeout(timeout);

      timeout = setTimeout(later, wait);

      if (callNow) func.apply(context, args);
    };
  },
  setHeaderOnScroll: function () {
    let header = document.querySelector('#header');

    if (header) {
      window.addEventListener('scroll', store.throttle(() => {
        window.scrollY > 110 ? header.classList.add('fixed') : header.classList.remove('fixed')
      }));
    }
  },
  setProductBlockImages: function () {
    const colors = document.querySelectorAll('[data-product-block-color]');
    if (colors.length > 0) colors.forEach(color => {
      let block = color.closest('[data-product-block]');
      let id = color.getAttribute('data-product-block-color');

      if (color.hasAttribute('data-processed')) return;
      
      color.addEventListener('click', (e) => {
        e.preventDefault();
        // console.log('click 24/4', color)
        let colorUrlBlock = color.querySelector('[data-product-url]')
        if (colorUrlBlock){
          let colorUrlAttr = colorUrlBlock.getAttribute('data-product-url')
          block.querySelector('a').href = colorUrlAttr
        }

        if (!color.classList.contains('active')) {
          if (block.querySelector('[data-product-block-figure].active')) block.querySelector('[data-product-block-figure].active').classList.remove('active');
          if (block.querySelector(`[data-product-block-figure="${id}"]`)) block.querySelector(`[data-product-block-figure="${id}"]`).classList.add('active');
          if (block.querySelector('[data-product-block-color].active')) block.querySelector('[data-product-block-color].active').classList.remove('active');
          if (block.querySelector(`[data-product-block-color="${id}"]`)) block.querySelector(`[data-product-block-color="${id}"]`).classList.add('active');
        }
      });
      color.setAttribute('data-processed', true);
    });
  },
  home: {
    setPrimaryBanner: function () {
      let banners = document.querySelectorAll("[data-slider-primary]");

      banners.forEach((slider) => {
        var slider = new Swiper(slider, {
          slidesPerView: 1,
          spaceBetween: 0,
          watchOverflow: true,
          autoplay: {
            delay: 10000
          },
          lazy: {
            checkInView: true,
            loadOnTransitionStart: true,
            loadPrevNext: true,
            loadPrevNextAmount: 1
          },
          speed: 800,
          navigation: {
            nextEl: slider.querySelector(".swiper-button-next"),
            prevEl: slider.querySelector(".swiper-button-prev"),
          },
          pagination: {
            el: slider.querySelector(".swiper-pagination"),
            type: "bullets",
            clickable: true,
          },
        });
      });
    },


    setSliderInstagram: function () {
      $('[data-slider-instagram]').each(function (index, el) {

        var swiperInstagramCarousel = new Swiper($(el), {
          spaceBetween: 2,
          watchOverflow: true,
          loop: true,
          breakpoints: {
            280: {
              slidesPerView: 2.15
            },
            640: {
              slidesPerView: 4
            },
            992: {
              slidesPerView: 5
            }
          }
        });
      });
    },

    // Aqui ficam os js da home
    init: function () {
      this.setPrimaryBanner();
      this.setSliderInstagram();
      store.setQuickBuy();
    },
  },
  product: {
    // Aqui ficam os js do transacional
    $sectionProduct: $('[data-section-product]'),
    $wrapperImages: $('[data-section-product]').find('[data-product-images]'),
    $sliderProduct: $('[data-section-product]').find('[data-product-images] [data-main-slider]'),
    $thumbsProduct: $('[data-section-product]').find('[data-product-images] [data-slider-thumbs]'),
    sliderProduct: [],
    /* 
      Exibe as primeiras imagens do produto
      ** Importante para quando houver imagem por sku **
    */
    showFirstImages: function () {
      var _this = this;
      var variants = vnda.variants.all();
      var $imagesWithoutSkus = _this.$sliderProduct.find('.image-without-sku');
      var $thumbsWithoutSkus = _this.$thumbsProduct.find('.image-without-sku');

      if ($imagesWithoutSkus.length > 0) {
        /* 
          Todas as imagens sem skus são exibidas sempre
        */

        $imagesWithoutSkus.removeClass('inactive').addClass('active');

        $thumbsWithoutSkus.removeClass('inactive').addClass('active');
      } else {
        /* 
          Percorre todas as variantes
        */
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].main) {
            console.info(variants[i]);

            // Procura a imagem que contém o sku e a exibe
            _this.$sliderProduct
              .find('[data-image][data-skus-image*="' + variants[i].sku + '"]')
              .addClass('active')
              .removeClass('inactive');

            _this.$thumbsProduct
              .find('[data-image-thumb][data-skus-image*="' + variants[i].sku + '"]')
              .addClass('active')
              .removeClass('inactive');
          }
        }
      }
    },
    setGallery: function () {
      var _this = this;

      var galleryThumbs = new Swiper('.swiper-container[data-slider-thumbs]', {
        direction: 'vertical',
        spaceBetween: 5,
        slidesPerView: 9,
        navigation: {
          nextEl: $('.swiper-container[data-slider-thumbs]').find('.swiper-button-next'),
          prevEl: $('.swiper-container[data-slider-thumbs]').find('.swiper-button-prev'),
        },
      });

      var gallery = new Swiper(_this.$sliderProduct, {
        speed: 500,
        slidesPerView: 1,
        direction: 'vertical',
        mousewheel: true,
        thumbs: {
          swiper: galleryThumbs,
        },

        navigation: {
          nextEl: $('.swiper-container[data-main-slider]').find('.swiper-button-next'),
          prevEl: $('.swiper-container[data-main-slider]').find('.swiper-button-prev'),
        },
        pagination: {
          el: $('.swiper-container[data-main-slider]').siblings('.swiper-pagination'),
          type: 'progressbar',
          clickable: true
        },
        breakpoints: {
          280: {
            direction: 'horizontal'

          },
          992: {
            direction: 'vertical',
            allowTouchMove: false
          }
        },
      });

      this.sliderProduct.push(gallery);
      this.sliderProduct.push(galleryThumbs);

      $(document).on('click', '[data-image-thumb]:visible', function () {
        gallery.slideTo($(this).index('[data-image-thumb]:visible'));
        let activeZoom = $('.mz-active').closest('[data-image-product]').attr('id');
        MagicZoom.zoomOut(activeZoom)
      });

      $(document).on('mouseleave', '[data-image-product]:visible', function () {
        let activeZoom = $('.mz-active').closest('[data-image-product]').attr('id');
        MagicZoom.zoomOut(activeZoom)
      });

      gallery.on('slideChange', function () {
        let activeZoom = $('.mz-active').closest('[data-image-product]').attr('id');
        MagicZoom.zoomOut(activeZoom)
      });
    },

    setCrossSellingCarousel: function () {
      var swiperCrossSelling = new Swiper($('[data-cross-selling-carousel]'), {
        watchOverflow: true,
        navigation: {
          nextEl: $('[data-cross-selling-carousel]').siblings('.swiper-button-next'),
          prevEl: $('[data-cross-selling-carousel]').siblings('.swiper-button-prev'),
        },
        breakpoints: {
          280: {
            slidesPerView: 1.5,
            spaceBetween: 30
          },
          520: {
            spaceBetween: 10,
            slidesPerView: 2
          }
        }
      });
    },

    setRelatedsCarousel: function () {
      var swiperRelateds = new Swiper($('[data-relateds-carousel]'), {
        slidesPerView: 4,
        watchOverflow: true,
        breakpoints: {
          325: {
            slidesPerView: 1,
            spaceBetween: 15,
            loop: true
          },
          640: {
            spaceBetween: 21,
            slidesPerView: 3,
            loop: false
          },
          1200: {
            loop: false,
            spaceBetween: 80,
            slidesPerView: 4,
          },
        },
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: $('[data-relateds-carousel]').siblings('.swiper-button-next'),
          prevEl: $('[data-relateds-carousel]').siblings('.swiper-button-prev'),
        },
      });
    },

    setSizeGuide: function () {
      const $btnSizeGuide = $('[data-action="toggle-size-guide"]');
      const $overlay = $('[data-overlay]');
      const $popupSizeGuide = $('[data-popup-size-guide]');

      $btnSizeGuide.on('click', function (e) {
        e.preventDefault();

        $overlay.toggleClass('active');
        $popupSizeGuide.toggleClass('visible');
      });

      $overlay.on('click', function () {
        $(this).toggleClass('active');
        $popupSizeGuide.toggleClass('visible');
      })
    },

    submitNotify: function () {
      $(document).on('submit', '[data-form-notify]', function (event) {
        event.preventDefault();
        template_store.submitFormNotify($(this));
      });
    },

    addToCartSet: function (skusInputs, $form) {
      const skus = skusInputs.map(input => input.value);
      var $boxResponse = $('[data-box-produto]').find('[data-form-product] .add-to-cart-button');
      var respValidated = store.validateFormProduct($form);

      const result = store.addItemArray(skus);
      result
        .then(() => {
          setTimeout(function () {
            $('.add-to-cart-button').removeClass('unavailable');
          }, 3000);
          template_store.headerCart.show();
        })
        .catch((resp) => {
          if (respValidated.validated) {

            if (typeof template_store.addItemResult == 'function') {
              template_store.addItemResult($form, 'erro-adicionar', resp, $boxResponse);
            } else {
              template_store.addItemResultDefault($form, 'erro-adicionar', resp, $boxResponse);
            }

            setTimeout(function () {
              $('.add-to-cart-button').removeClass('unavailable');
            }, 3000);

          } else {
            //console.info('não foi');
            store.setRespValidateProduct(respValidated, $form, $boxResponse);
          }
          
        })
    },

    setBottomBar: function () {
      const sizes = document.querySelector('[data-product-sizes]');

      if (sizes) {
        const sku = sizes.querySelector('input[name="sku"]');
        const button = document.querySelector('.bottom-bar .add-to-cart-button');

        const open = document.querySelector('[data-product-sizes-open]');
        open.addEventListener('click', () => { sizes.classList.add('-active') });

        const closes = document.querySelectorAll('[data-product-sizes-close]');
        closes.length > 0 && closes.forEach(close => { close.addEventListener('click', () => { sizes.classList.remove('-active') }) });

        const inputs = sizes.querySelectorAll('input');
        inputs.length > 0 && inputs.forEach(input => {
          input.checked = false;
          input.addEventListener('change', () => {
            sizes.classList.remove('-active');
            
            if (input.checked) {
              button.classList.remove('-disabled');

              let text = input.nextElementSibling.querySelector('.text').innerHTML;

              open.innerHTML = `${text} <span>+</span>`;
              window.productVariants.forEach(v => { 
                if (v.properties.property2.value == text) {
                  sku.value = v.sku;

                  // Ajusta SKU do form de referência do envio
                  const mainFormSku = document.querySelector('.product-infos [data-form-product] [name="sku"]')
                  if (mainFormSku) {
                    mainFormSku.value = v.sku
                    mainFormSku.setAttribute('value', v.sku)
                  }
                  
                  // Ajusta texto de estoque
                  if (v.available) {
                    if (v.available_quantity <= 4) {
                      let propertyValue = v.properties.property1.value.toLowerCase();
                      let variantAvailableText = `Resta(m) apenas ${v.available_quantity} unidade(s) deste produto.`;
                      
                      if (propertyValue == 'top') {
                        $('.quantity-text-top').removeClass('hidden');
                        $('.quantity-text-top').find('span').text(variantAvailableText)
                      } else if (propertyValue == 'bottom') {
                        $('.quantity-text-bottom').removeClass('hidden');
                        $('.quantity-text-bottom').find('span').text(variantAvailableText)
                      } else {
                        $('.quantity-text').removeClass('hidden');
                        $('.quantity-text').find('span').text(variantAvailableText)
                      }
                    } else {
                      if (propertyValue == 'top') {
                        $('.quantity-text-top').addClass('hidden');
                      } else if (propertyValue == 'bottom') {
                        $('.quantity-text-bottom').addClass('hidden');
                      } else {
                        $('.quantity-text').addClass('hidden');
                      }
                    } 
                  } else {
                    $('.quantity-text').addClass('hidden');
                  }
                
                  let btn = document.querySelector('.add-to-cart-button');
                  let notify = document.querySelector('[data-box-produto] [data-form-notify]');
                  if (v.available) {
                    btn.innerHTML = btn.getAttribute('data-text-available');
                    btn.classList.remove('unavailable');
                    notify.classList.remove('active');
                    notify.querySelector('input[name="sku"]').value = '';
                  } else {
                    btn.innerHTML = btn.getAttribute('data-text-unavailable');
                    btn.classList.add('unavailable');
                    notify.classList.add('active');
                    notify.querySelector('input[name="sku"]').value = v.sku;
                  }
                };
              });
            }
          });
        });

        const toggle = document.querySelector('[data-product-colors-toggle]');
        const colors = document.querySelector('[data-product-colors-in]');
        if (toggle && colors) toggle.addEventListener('click', () => { colors.classList.toggle('-active') });
      }
    },

    setMobileAccordion: function (_element) {

      console.log(_element);
      document.querySelectorAll('[data-tab-toggle]').forEach(item => {
        if(!(_element === item)) {
          item.classList.remove('active');
          item.nextElementSibling.style.maxHeight = null;
        }
      });

      _element.classList.toggle('active');

      const panel = _element.nextElementSibling;

      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    },

    init: function () {
      var _this = this;

      _this.showFirstImages();
      _this.setGallery();
      _this.setCrossSellingCarousel();
      _this.setRelatedsCarousel();
      _this.submitNotify();
      _this.setSizeGuide();
      _this.setBottomBar();
      store.setQuickBuy();

      const toggleTabs = document.querySelectorAll('[data-tab-toggle]');
      toggleTabs.forEach(toggleTab => {
        toggleTab.addEventListener('click', () => {
          _this.setMobileAccordion(toggleTab);
        });
      })

      const quickBuyMobile = document.querySelectorAll('.quick-add-mobile');

      quickBuyMobile.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          btn.nextElementSibling.classList.toggle('-visible-on-mobile');
        })
      });

      $(document).on('submit', store.config.selectorFormProduct, function (event) {
        event.preventDefault();

        var $form = $(this);
        var $parent = $form.closest(store.config.selectorWrapperProduct);

        if ($('[data-box-produto] [data-product-attributes]').length > 1) {
          $('.add-to-cart-button').addClass('unavailable');
          const skusInputs = [...document.querySelectorAll('[data-box-produto] [data-form-product] [name=sku]')];
          _this.addToCartSet(skusInputs, $form);

        } else {
          var $btnComprar = $parent.find(store.config.selectorBtnBuy);

          var respValidated = store.validateFormProduct($form);
          var $boxResponse = $parent.find('.add-to-cart-button');

          if (respValidated.validated) {
            store.addItem($form, $parent);
          } else {
            console.info('não foi');
            setTimeout(()=> {
              store.setRespValidateProduct(respValidated, $form, $boxResponse);
            }, 150)
          }
        }
      });
    },
  },
  tag: {
    //Aqui ficam os js da listagem

    init: function () {
      var _this = this;

      store.setQuickBuy();
      store.setQuickView();
      store.setFilters();
      store.setFilterSelected();
      store.setImagesBetweenProducts();

      const quickBuyMobile = document.querySelectorAll('.quick-add-mobile');

      quickBuyMobile.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          btn.nextElementSibling.classList.toggle('-visible-on-mobile');
        })
      });
    },
  },
  search: {
    init: function () {
      store.setQuickBuy();
      store.setFilters();
      store.setFilterSelected();

      const quickBuyMobile = document.querySelectorAll('.quick-add-mobile');

      quickBuyMobile.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          btn.nextElementSibling.classList.toggle('-visible-on-mobile');
        })
      });
    }
  },
  page: {
    setShowMoreCardsButton: function () {
      const $btnShowMore = $('[data-action="show-more"]');
      const $cards = $('.card');
      const totalCards = $cards.length;
      const initialCardsMobile = 4;
      const cardsPerClick = 2;
      let visibleCards = initialCardsMobile;

      $cards.slice(initialCardsMobile).addClass('hidden');

      $btnShowMore.on('click', function () {
        $cards.slice(visibleCards, visibleCards + cardsPerClick).removeClass('hidden');
        visibleCards = $('.card:not(.hidden)').length;

        if (totalCards == visibleCards) {
          $(this).hide();
        }
      })
    },

    setSliderTimeline: function () {
      $('[data-slider-timeline]').each(function (index, el) {

        var swiperTimelineCarousel = new Swiper($(el), {
          spaceBetween: 25,
          watchOverflow: true,
          breakpoints: {
            280: {
              slidesPerView: 1
            },
            520: {
              slidesPerView: 2
            },
            767: {
              slidesPerView: 3
            },
            1200: {
              slidesPerView: 4
            }
          },
          navigation: {
            nextEl: $(el).closest('.wrapper-banners').find('.swiper-button-next'),
            prevEl: $(el).closest('.wrapper-banners').find('.swiper-button-prev'),
          },
        });
      });
    },

    setUploadedFile: function () {
      $('[name="curriculo"]').on('change', function (e) {
        let file = e.target.value;
        file = file.split('\\').pop()

        if (!file) {
          file = 'Carregar currículo (PDF ou DOC)'
        }

        $('[data-file-uploaded]').text(file)
      })
    },

    setSliderStudios: function () {
      let swiperStudios = document.querySelectorAll("[data-slider-studios]");

      swiperStudios.forEach((slider) => {
        var slider = new Swiper(slider, {
          spaceBetween: 32,
          watchOverflow: true,
          navigation: {
            nextEl: slider.querySelector(".swiper-button-next"),
            prevEl: slider.querySelector(".swiper-button-prev"),
          },
          breakpoints: {
            280: {
              slidesPerView: 1
            },
            520: {
              slidesPerView: 2
            },
            767: {
              slidesPerView: 3
            },
            1200: {
              slidesPerView: 4
            }
          }
        });
      });
    },
    collabs: {
      topContentAnimations: function () {
        const topTexts = document.querySelectorAll("[data-initial-text]");
        const bottomTexts = document.querySelectorAll("[data-main-text]");

        window.addEventListener("scroll", function () {
          const scrollY = window.scrollY;
          
          topTexts.forEach(topText => {
            //Cálculos para o primeiro texto
            const calcUpText = (scrollY / 2).toFixed(0);
            if (calcUpText <= 0) {
              topText.style.transform = 'translateY(0)'
              topText.style.opacity = '1'
            } else { 
              let opacityCalc = (2.5 / calcUpText) * 5;
              topText.style.transform = `translateY(-${calcUpText}px)`;
              opacityCalc <= 0.20 ? topText.style.opacity = "0" : topText.style.opacity = `${opacityCalc}`
            }
          })

          bottomTexts.forEach(bottomText => {
            //Cálculos para o segundo texto
            const calcBottomText = (scrollY / 6.5).toFixed(0);
            var limitToUp = 40;

            if (calcBottomText <= 0) {
              bottomText.style.bottom = "0%";
              bottomText.style.opacity = "0";
            } else {
              if (calcBottomText >= limitToUp) {
                bottomText.style.bottom = `${limitToUp}%`;
                bottomText.style.opacity = "1";
              } else {
                let opacityBottomCalc = (calcBottomText / 4) / 10;
                bottomText.style.bottom = `${calcBottomText}%`;
                opacityBottomCalc <= 0.20 ? bottomText.style.opacity = "0" : bottomText.style.opacity = `${opacityBottomCalc}`
              }
            }
          })
          
        });
      },
      bottomContentAnimations: async function () {
        const topContentHeight = document.querySelector("[data-top-content]").offsetHeight;
        const bottomContainer = document.querySelector("[data-bottom-content]");
        const elementTranslated = document.querySelector("[data-translated-element]");
        const rightBanners = document.querySelectorAll("[data-right-banner]");
        const header = document.getElementById("header");
        let element;

        $body.width() > 992
        ? element = document.getElementById("section-products")
        : element = document.getElementById("collab-banner");
        
        window.addEventListener("scroll", () => {
          const offsetTop = bottomContainer.getBoundingClientRect().top;
          const headerHeight = header.offsetHeight;
          const calcHeaderLimit = offsetTop - headerHeight;

          //Translate inicia somente abaixo do top-content
          var calcTranslate = window.scrollY - topContentHeight;
          
          //limita scroll entre header e o footer
          if (!element.classList.contains("isIntersecting") && calcHeaderLimit <= 5) {

            //exibe todos elementos
            rightBanners.forEach(banner => {
              banner.classList.remove("-hidden");
            })

            calcHeaderLimit <= 5 ?
              elementTranslated.style.transform = `translate3d(0, calc(-40% + ${calcTranslate}px), 0)` :
              elementTranslated.style.transform = `translate3d(0, -40%, 0)`
          } else {

            //Esconde os elementos que já passaram do footer - garante que nenhum espaçamento indevido apareça
            if (element.classList.contains("isIntersecting")) {
              rightBanners.forEach(banner => {
                banner.classList.add("-hidden")
              })
            }
            
          }
        });

      },
      observerElements: function () {
        let element;
        let optionsElement = {}

        if($body.width() > 992 ) {
          element = document.getElementById("section-products");
        }else {
          element = document.getElementById("collab-banner");
          optionsElement = { rootMargin: "0px 0px 0px 0px"}
        }

        const elementObserver = new IntersectionObserver(function (entries, observer) {
          entries.forEach(entry => {
            if (!entry.isIntersecting) {
              entry.target.classList.remove("isIntersecting")
              return entry.target;

            } else {
              entry.target.classList.add("isIntersecting")
              return entry.target;
            }

          })
        }, optionsElement)
        elementObserver.observe(element)
      },
    },

    init: function () {
      var _this = this;

      _this.setSliderStudios();
      _this.setUploadedFile();
      _this.setSliderTimeline();

      if ($body.width() <= 767) {
        _this.setShowMoreCardsButton();
      }

      if (window.location.href.includes("bicsoleil") || window.location.href.includes("collab-")) {
        _this.collabs.topContentAnimations();
        _this.collabs.bottomContentAnimations();
        _this.collabs.observerElements();
        store.setQuickView();
      }
    }
  },
  login: {
    init: function () {
      $('[data-content-login]').each(function (index, el) {
        // Animação
        $(el).on('click', '[data-forget-password]', function (event) {
          event.preventDefault();
          $(el).find('.wrapper-form-login').animate({
            height: 'toggle'
          }, 500);
          $(el).find('.wrapper-form-recover').animate({
            height: 'toggle'
          }, 500);
        });

        $(el).on('click', '[data-forget-password-back]', function (event) {
          event.preventDefault();
          $(el).find('.wrapper-form-login').animate({
            height: 'toggle'
          }, 500);
          $(el).find('.wrapper-form-recover').animate({
            height: 'toggle'
          }, 500);
        });

        $(el).on('submit', '[data-form-login]', function (event) {
          event.preventDefault();

          var $form = $(this);
          var respValidated = store.login.validateLogin($form);

          if (respValidated.validated) {
            store.login.logar($form);
          } else {
            store.setMsgResponse(respValidated.errors, 'error', $(this));
          }
        });

        $(el).on('submit', '[data-form-register]', function (event) {
          event.preventDefault();

          var $form = $(this);
          var respValidated = store.login.validateRegister($form);

          if (respValidated.validated) {
            store.login.logar($form);
          } else {
            store.setMsgResponse(respValidated.errors, 'error', $(this));
          }
        });

        $(el).on('submit', '[data-form-recover]', function (event) {
          event.preventDefault();

          var $form = $(this);
          var respValidated = store.login.validateRecover($form);

          if (respValidated.validated) {
            store.login.recoverPassord($form);
          } else {
            store.setMsgResponse(respValidated.errors, 'error', $(this));
          }
        });
      });

      $("[data-forget-password]").on("click", function () {
        $(".form-recover").slideDown()
        $(".form-login").slideUp()
      });

      $("[data-forget-password-back]").on("click", function () {
        $(".form-recover").slideUp()
        $(".form-login").slideDown()
      });
    },
  },
  init: function () {
    var _this = this;
    store.getCartCount();
    store.setTopBar();
    store.setSearchForm();
    template_store.setHeaderOnScroll();
    store.setProductsCarousel();
    store.setToggleFooter();
    store.setMenuMobile();
    store.getPriceProd();
    
    _this.setProductBlockImages();

    // _this.headerCart.toggleBtn();
    _this.headerCart.observeKits();
    // ENVIO DE FORMULÁRIOS
    $('[data-webform]').on('submit', function (event) {
      event.preventDefault();
      var $form = $(this);
      var vnda = $(this).find('[name="vnda"]');

      if (vnda.length > 0) {
        if (vnda.val() != '') {
          //console.info('ROBOT DETECTED');
          return false;
        }
      }

      if ($form.data('webform') == 'newsletter') {
        var respValidated = _this.validateFormNewsletter($(this));
        var htmlErrors = '';

        if (respValidated.validated) {
          store.submitForm($(this), false, function () {
            store.setMsgResponse(false, 'clear', $(this));
          });
        } else {
          console.log('nao foi')
          store.setMsgResponse(respValidated.errors, 'error', $(this));
        }

      } else if ($form.data('webform') == 'contato') {
        store.submitForm($form, false, function () {
          store.setMsgResponse(false, 'clear', $(this));
        });
      } else {
        store.submitForm($form);
      }

    });
  },
};

window.addEventListener('DOMContentLoaded', () => {
  template_store.init();

  if (page == 'home') {
    template_store.home.init();
  }

  if (page == 'product') {
    template_store.product.init();
  }

  if (page == 'tag') {
    template_store.tag.init();
  }

  if (page == 'search') {
    template_store.search.init();
  }

  if (page == 'page') {
    template_store.page.init();
  }

  if (page == 'login') {
    template_store.login.init();
  }
});

console.log(
  '%cVnda - Tecnologia em Ecommerce',
  'color: #f88d5b; font-size: 15px; font-family: "Verdana", sans-serif; font-weight: bold;'
);
